import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider, createTheme } from "@mui/material";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const text = "#00395A";

const THEME = createTheme({
  palette: {
    text: {
      primary: text,
      secondary: text,
    },
  },
  typography: {
    fontFamily: `"Fredoka", "Nunito", "Comfortaa", "Quicksand", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif`,
  },
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={THEME}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
